"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = {
    root: {
        display: "flex",
        fill: "currentColor",
        transition: "fill 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        userSelect: "none",
        alignItems: "center",
        width: "100%",
        height: "100%",
        justifyContent: "center",
    },
    // This is a generic wrapper for all data fields and input types.
    // SVGs and icon resets
    "svg:not(:root)": {
        overflow: "hidden",
    },
    icon: {
        height: "100%",
    },
};
exports.default = styles;
//# sourceMappingURL=styles.js.map